function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.288 34H8.74c-3.126.022-6.02-1.684-7.571-4.462a8.887 8.887 0 0 1 0-8.811l9.315-16.304C12.047 1.683 14.914 0 18.014 0c3.1 0 5.966 1.684 7.53 4.423l9.287 16.304a8.887 8.887 0 0 1 0 8.81c-1.545 2.77-4.427 4.474-7.543 4.463zM18.014 2.836c-2.116-.019-4.078 1.129-5.135 3.004L3.59 22.158a5.997 5.997 0 0 0 0 5.963c1.047 1.898 3.02 3.064 5.149 3.046h18.548c2.135.024 4.113-1.143 5.163-3.046a5.997 5.997 0 0 0 0-5.963L23.149 5.84c-1.058-1.875-3.02-3.023-5.135-3.004z",
  fill: "red",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.014 11.336a.742.742 0 0 0-.61.311.75.75 0 0 0-.138.68l.748 3.088.747-3.088a.75.75 0 0 0-.138-.68.742.742 0 0 0-.61-.311z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.782 9.92a3.514 3.514 0 0 0-2.768-1.364 3.514 3.514 0 0 0-2.768 1.363 3.606 3.606 0 0 0-.637 3.102l2.02 8.57a1.39 1.39 0 0 0 1.343 1.072 1.39 1.39 0 0 0 1.343-1.072l2.09-8.584a3.606 3.606 0 0 0-.623-3.088zm-2.02 2.407-.748 3.088-.748-3.088a.75.75 0 0 1 .139-.68.756.756 0 0 1 .609-.311c.24 0 .465.115.609.311a.75.75 0 0 1 .138.68z",
  fill: "red",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "red",
  fillRule: "nonzero",
  cx: 18.014,
  cy: 26.209,
  rx: 2.076,
  ry: 2.125
}));

function SvgDanger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.6dab53a2.svg";
export { ForwardRef as ReactComponent };